import { useQuery } from "@tanstack/react-query";
import { getProductRequest } from "../requests/product";

export function useProducts({ params }) {
  return useQuery({
    queryKey: ["product", params],
    queryFn: async () => {
      const res = await getProductRequest({ params });
      return res.data?.data;
    },
  });
}
